import { Colors } from 'src/shared/components/styles';
import { MoreVert, Download } from '@mui/icons-material';
import {
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Box,
  Tooltip,
} from '@mui/material';
import { DocumentResponse } from 'src/shared/services/api/response/documentResponse';
import { useTranslation } from 'react-i18next';
import { StatsRangeBadge } from 'src/shared/components/atoms/statsRangeBadge';

type DocumentItemProps = {
  item: DocumentResponse;
  handleClickShowActionMenu: (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => void;
  onDownloadFileClicked: (item: DocumentResponse) => void;
  onOpenFileClicked: (item: DocumentResponse) => void;
  enableStatsRange: boolean;
  rangeDays: number;
  onRangeChange: (rangeDays: number) => void;
  allDownloads: number | null;
  uniqueDownloads: number | null;
};

// const PREVIEWABLE_MIMES = new Set([
//   'image/bmp',
//   'text/csv',
//   'application/vnd.oasis.opendocument.text',
//   'application/msword',
//   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//   'image/gif',
//   'text/html',
//   'image/jpeg',
//   'application/pdf',
//   'image/png',
//   'application/vnd.ms-powerpoint',
//   'application/vnd.openxmlformats-officedocument.presentationml.presentation',
//   'image/tiff',
//   'text/plain',
//   'application/vnd.ms-excel',
//   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
// ]);

// function canPreviewByMime(mime?: string): boolean {
//   return mime ? PREVIEWABLE_MIMES.has(mime.toLowerCase()) : false;
// }

export const DocumentItemComponent = ({
  item,
  handleClickShowActionMenu,
  onDownloadFileClicked,
  onOpenFileClicked,
  enableStatsRange,
  rangeDays,
  onRangeChange,
  allDownloads,
  uniqueDownloads,
}: DocumentItemProps) => {
  const { t } = useTranslation();
  return (
    <ListItem
      divider
      disablePadding
      key={item.id}
      secondaryAction={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {enableStatsRange && (
            <StatsRangeBadge
              label={t('DownloadsLabelShort')}
              rangeDays={rangeDays}
              value={allDownloads}
              uniqueValue={uniqueDownloads}
              onRangeChange={onRangeChange}
            />
          )}
          <Tooltip title={t('Download')}>
            <IconButton
              edge='end'
              aria-label='download'
              onClick={(e) => {
                e.stopPropagation();
                onDownloadFileClicked(item);
              }}
            >
              <Download />
            </IconButton>
          </Tooltip>

          <Tooltip title={t('More')}>
            <IconButton
              edge='end'
              aria-label={t('more')}
              onClick={(e) => {
                e.stopPropagation();
                handleClickShowActionMenu(e);
              }}
            >
              <MoreVert sx={{ color: Colors.ORANGE }} />
            </IconButton>
          </Tooltip>
        </Box>
      }
    >
      <ListItemButton
        onClick={() => onOpenFileClicked(item)}
        sx={{
          cursor: 'pointer',
          transition: 'background-color 120ms ease',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          '& .MuiListItemText-primary': {
            textDecoration: 'none',
          },
          '&:hover .MuiListItemText-primary': {
            textDecoration: 'underline',
          },
        }}
      >
        <ListItemText
          primaryTypographyProps={{ fontSize: 14, color: 'primary.main' }}
          primary={item.name}
          sx={{ paddingRight: 16 }}
        />
      </ListItemButton>
    </ListItem>
  );
};
